import { Box } from '@cast/design-system';

type Props = {
  children: React.ReactNode;
};

export const DescriptionContainer = ({ children }: Props) => (
  <Box
    sx={{
      color: '#525866',
      textAlign: 'center',
      fontFamily: 'Soehne Buch',
      fontSize: '14px',
      lineHeight: '22px',
    }}
    data-testid="error-description"
  >
    {children}
  </Box>
);
